import React, { useMemo } from 'react';
import { useContextSelector } from 'use-context-selector';
import { MarkdownOpenExternalLinkCtx } from '../ctx/OpenExternalLinkCtx';
import { Link } from '@remix-run/react';

const TagA = React.forwardRef<
  HTMLAnchorElement,
  React.DetailedHTMLProps<React.AnchorHTMLAttributes<HTMLAnchorElement>, HTMLAnchorElement>
>(function (props, ref) {
  const openExternalLink = useContextSelector(
    MarkdownOpenExternalLinkCtx,
    (data) => data.openExternalLink,
  );
  const slugIdPrefix = useContextSelector(MarkdownOpenExternalLinkCtx, (data) => data.slugIdPrefix);
  const isSupportHash = useContextSelector(
    MarkdownOpenExternalLinkCtx,
    (data) => data.isSupportHash,
  );
  const enableHeadingSlugId = useContextSelector(
    MarkdownOpenExternalLinkCtx,
    (data) => data.enableHeadingSlugId,
  );

  const renderExternalLink = useContextSelector(
    MarkdownOpenExternalLinkCtx,
    (data) => data.renderExternalLink,
  );

  const activeHref = useMemo(() => {
    if (props.href?.startsWith('#')) {
      return decodeURI(`#${slugIdPrefix}${props.href.substring(1)}`);
    }
    return props.href ? renderExternalLink(props.href) : props.href;
  }, [props.href, slugIdPrefix, renderExternalLink]);

  const target = React.useMemo(() => {
    if (props.target) {
      return props.target;
    }
    if (activeHref?.startsWith('#') || activeHref?.startsWith('/')) {
      return undefined;
    }

    return '_blank';
  }, []);

  return (
    <Link
      {...props}
      data-href={activeHref || undefined}
      to={activeHref || undefined}
      onClick={(e) => {
        if (activeHref?.startsWith('#')) {
          try {
            if (enableHeadingSlugId && activeHref !== '#') {
              const el = document.querySelector(activeHref);
              el?.scrollIntoView({});
            }
          } catch (e) {
            console.error(e);
          }
          if (!isSupportHash) e.preventDefault();
          return;
        }
        openExternalLink?.(activeHref, e.nativeEvent);
      }}
      target={target}
      ref={ref}
    />
  );
});

export { TagA };
